import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';
import { MappingFilter } from 'app/admin/importclient/mapping-filter.model';

@Injectable()
export class ImportClientService {
    private selectFilter = new BehaviorSubject<any>('');
    currentMappingFilter = this.selectFilter.asObservable();
    constructor(private requestService: ObservableRequestService) { }

    getMappingFilters(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.IMPORT_CLIENT_MAPPING_FILTERS)
            .map(response => {
                return plainToClass(MappingFilter, response.arrResult as Object[]);
            });
    }

    getMappingINSTRUCTIONS(selectdFilter: any): Observable<any> {
        return this.requestService.getRequest(ConstantsService.IMPORT_CLIENT_MAPPING_INSTRUCTIONS +
            '?provider=' + selectdFilter.provider + '&version=' + selectdFilter.version);
    }

    sendFilter(message: string) {
        this.selectFilter.next(message);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/import-client.service.ts